import { Dispatch, SetStateAction, ReactNode } from "react";
import classNames from "classnames";
import { Typography } from "components/atoms/Typography";
import "./index.scss";

interface TabData {
  id: number;
  icon: ReactNode;
  label: string;
  route: string;
  dropdown?: {
    isVisible: boolean;
    routes: {
      id: number;
      label: string;
    }[]
  }
}

interface IProps {
  activeTab: number;
  setActiveTab: Dispatch<SetStateAction<number>>;
  tabs: TabData[];
  style?: string;
  toggleItemsView?: boolean;
  setToggleItemsView?: Dispatch<SetStateAction<boolean>>;
  handleNavigation: (tabId: number, route: string, subRouteId?: number) => void;
}

export const NavItems = ({
  activeTab,
  tabs,
  style,
  handleNavigation,
}: IProps) => {
  return (
    <nav className={classNames("nav-wrapper", style && `${style}`)}>
      <ul>
        {tabs.map((tab) => (
          <li key={tab.id} onClick={() => handleNavigation(tab.id, tab.route)}>
            <div
              className={classNames({
                "nav-item-wrapper": true,
                active: activeTab === tab.id,
              })}
            >
              {tab.icon}
              <Typography
                styles="nav-item-label"
                variant="h6Medium"
                label={tab.label}
              />
            </div>
              {
                  tab.dropdown?.isVisible && tab.dropdown.routes?.length > 0 && (
                      <ul className='nav-sub-list'>
                          {
                              tab.dropdown.routes.map(subRoute => (
                                  <li
                                      key={`${tab.id}_${subRoute.id}`}
                                      onClick={(e) => {
                                          e.stopPropagation();
                                          handleNavigation(tab.id, tab.route, subRoute.id)
                                      }}
                                  >
                                      <Typography
                                          variant="h7Med"
                                          label={subRoute.label}
                                      />
                                  </li>
                              ))
                          }
                      </ul>
                  )
              }
          </li>
        ))}
      </ul>
    </nav>
  );
};
